import clsx from "clsx";
import type { ReactNode } from "react";

type Props = {
  checked: boolean;
  error?: boolean;
  onChange: () => void;
  isVertical?: boolean;
  children?: ReactNode;
  className?: string;
};
export const RadioBasic = ({ children, checked, error, isVertical, className, onChange }: Props) => {
  return (
    <label
      className={clsx(
        className,
        "flex items-center cursor-pointer min-h-[24px] min-w-[24px] relative select-none group",
        {
          "pl-0 pt-8 justify-center": isVertical,
          "pl-8": !isVertical,
          "text-primary": !error,
          "text-[#C92A2A]": error,
        },
      )}
    >
      {children}
      <input className="cursor-pointer opacity-0 absolute" type="radio" checked={checked} onChange={onChange} />
      <span
        className={clsx(
          "rounded-full after:rounded-full bg-transparent border h-6 w-6 absolute after:content-[' '] after:w-[18px] after:h-[18px] after:absolute after:top-0.5 after:left-0.5 after:bg-pr-1 group-hover:shadow-xs group-hover:shadow-primary/75",
          {
            "top-0 left-1/2 -translate-x-1/2": isVertical,
            "left-0 top-[calc(50%-12px)]": !isVertical,
            "after:hidden": !checked,
            "border-tx-2": !checked && !error,
            "border-pr-1": checked && !error,
            "border-[#C92A2A]": error,
          },
        )}
      />
    </label>
  );
};
